<template>
  <DialogTemplateToolkit
    class-name="comment-dialog"
    :dialog="dialog"
    :disabled=" !text"
    first_btn="Common.Send"
    :title="title"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <sButton
        v-if="!list_item"
        color="var(--white-color)"
        icon="comment"
        type="text"
        @click="dialog = true"/>
      <MenuItem
        v-else
        class="h11-links"
        icon="comment"
        :label="$t('Common.ToComment')"
        @click="open"/>
    </template>
    <template #card-text>
      <sInput
        autofocus
        clearable
        :max-length="4000"
        max-rows="5"
        rows="5"
        type="textarea"
        :value.sync="text"/>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { eventBus } from '@/main'
import { mapGetters } from 'vuex'

export default {
  name: 'commentDialog',
  data() {
    return {
      CHAT_IN_DEVELOPMENT: true,
      dialog: false,
      text: ''
    }
  },
  props: {
    element: Object,
    list_item: Boolean,
    className: String,
    dialogueType: String,
    user: Object,
    joinChat: Function,
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR']),
    item: {
      get() {
        return this.element
      },
      set(value) {
        this.$emit('update:element', value)
      }
    },
    title() {
      let result = ''
      if (!this.item.rows) {
        result += this.$t('Purchasing.CommentPosition')
      }
      if (this.item.resource) {
        result += ' ' + this.item.resource.fullName
      } else {
        result += ' ' + this.item.resourceName
      }
      return result
    }
  },
  methods: {
    open() {
      setTimeout(() => this.dialog = true, 100)
    },
    async apply() {
      if ( !this.CHAT_IN_DEVELOPMENT ) {
        if (!this.isActiveSignalR) {
          eventBus.$emit('ShowSignalAlert', 'Відправка повідомлення')
          return
        }

        if (this.dialogueType == 'APP') {
          this.$notifier.notify(this.item.id, null, 'APP', this.text)
        }

        if (this.dialogueType == 'ROW') {
          this.$notifier.notify(this.item.headerId, this.item.id, 'APP', this.text)
        }
      }
      this.close()
      this.text = ''
    },
    close() {
      this.dialog = false
    }
  },
  components: {
    MenuItem,
    DialogTemplateToolkit
  }
}
</script>
